import { useEffect } from "react";
import {
  Box,
  Container,
  Card,
  CardActionArea,
  Grid,
  Typography
} from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import family from "./../../../../assets/images/family.svg";
import individual from "./../../../../assets/images/individual.svg";
import professional from "./../../../../assets/images/professional.svg";

const SelectPlan = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { session } = useSelector((state) => state.session);

  const ProfessionalStep = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "ProfPlanUsers",
      },
    });
  };
  const FamilylStep = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "FamilyPlan",
      },
      PostData: {
        sub: session?.sub,
        product_id: [14],
        email: session?.email,
      },
    });
  };
  const IndividualStep = () => {
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: "ChoosePlan",
        step: "IndividualPlan",
      },
      PostData: {
        sub: session?.sub,
        product_id: [15],
        email: session?.email,
      },
    });
  };

  const cardSx = {
    height: '100%',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: 3,
    },
  };

  const imageSx = {
    width: '100%',
    maxWidth: 120,
    height: 'auto',
    mb: 2,
  };

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          py: 4,
          animation: 'slideInLeft 0.5s ease-out',
          '@keyframes slideInLeft': {
            from: {
              opacity: 0,
              transform: 'translateX(-50px)',
            },
            to: {
              opacity: 1,
              transform: 'translateX(0)',
            },
          },
        }}
      >
        <Typography
          variant="h6"
          component="h6"
          sx={{
            textAlign: 'center',
            mb: 4,
          }}
        >
          {t("purchase.how_do_you_plan_to_use_our_platform")}
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                ...cardSx,
                animationDelay: '0.2s',
                animation: 'fadeInUp 0.6s ease-out forwards',
                opacity: 0,
                '@keyframes fadeInUp': {
                  from: {
                    opacity: 0,
                    transform: 'translateY(30px)',
                  },
                  to: {
                    opacity: 1,
                    transform: 'translateY(0)',
                  },
                },
              }}
            >
              <CardActionArea
                data-testid="buy_professionalPlan_btn"
                onClick={ProfessionalStep} sx={{ p: 3, textAlign: 'center', height: '100%' }}>
                <Box
                  data-testid="buy_professionalPlan_img"
                  component="img"
                  src={professional}
                  alt="professional woman working"
                  sx={imageSx}
                />
                <Typography
                  variant="p"
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    mb: 0,
                    color: '#662D91',
                  }}
                >
                  {t("purchase.i_want_to_use_it_with_my_patients")}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>

          {/* <Grid item xs={12} md={4}>
            <Card
              sx={{
                ...cardSx,
                animationDelay: '0.3s',
                animation: 'fadeInUp 0.6s ease-out forwards',
                opacity: 0,
              }}
            >
              <CardActionArea
                data-testid="buy_familyPlan_btn"
                onClick={FamilylStep} sx={{ p: 3, textAlign: 'center', height: '100%' }}>
                <Box
                  data-testid="buy_familyPlan_img"
                  component="img"
                  src={family}
                  alt="professional woman working"
                  sx={imageSx}
                />
                <Typography
                  variant="p"
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    mb: 0,
                    color: '#662D91',
                  }}
                >
                  {t("purchase.i_want_to_use_it_with_myself_and_my_family")}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid> */}

          <Grid item xs={12} md={6}>
            <Card
              sx={{
                ...cardSx,
                animationDelay: '0.4s',
                animation: 'fadeInUp 0.6s ease-out forwards',
                opacity: 0,
              }}
            >
              <CardActionArea
                data-testid="buy_individualPlan_btn"
                onClick={IndividualStep} sx={{ p: 3, textAlign: 'center', height: '100%' }}>
                <Box
                  data-testid="buy_individualPlan_img"
                  component="img"
                  src={individual}
                  alt="professional woman working"
                  sx={imageSx}
                />
                <Typography
                  variant="p"
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    mb: 0,
                    color: '#662D91',
                  }}
                >
                  {t("purchase.i_want_to_use_individually")}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          mt: 3,
          mx: 2,
          p: 2,
          backgroundColor: 'rgba(102, 45, 145, 0.1)',
          border: '1px solid #662D91',
          borderRadius: 1,
        }}
      >
        <InfoOutlined sx={{ color: '#662D91', fontSize: 20 }} />
        <Typography
          variant="body2"
          sx={{
            color: '#662D91',
            textAlign: 'center',
          }}
        >
          {t("purchase.cancel_your_plan_whenever_you_want")}
        </Typography>
      </Box>
    </>
  );
};

export default SelectPlan;